
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import {ExtraDossiersMetaData} from "@/models/module-extra-dossiers-meta-data";
import { PlanModule } from "@/models/plan-module";

export default FormLike.extend({
	data(){
		return {
			count: 0
		};
	},
	props: {
		value: {
			type: Object as ()=>PlanModule,
			required: true
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.count = ExtraDossiersMetaData.create(this.value.MetaData).getExtraDossiers();
			}
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		confirm(){
			if (!this.isValid) return;
			ExtraDossiersMetaData.create(this.value.MetaData).setExtraDossiers(this.count);
			this.$emit("close");
		}
	}
});
